<template>
    <span v-if="readonly" :class="colorClass">{{ questionValue }}</span>
    <TextField
        v-else-if="!notApplicable"
        :label="label"
        :disabled="readonly"
        :name="id"
        v-model="questionValue"
        type="number"
        :rules="required ? {required: true} : {}"
    />
</template>

<script>
import TextField from '@/components/widgets/forms/TextField';
export default {
    name: 'QuestionValue',
    components: { TextField },
    data: () => ({
        questionValue: null
    }),
    props: {
        id: {
            type: String
        },
        value: {
            type: [String, Number],
            'default': null
        },
        label: {
            type: String,
            'default': ''
        },
        incorrect: {
            type: Boolean,
            'default': false
        },
        readonly: {
            type: Boolean,
            'default': true
        },
        required: {
            type: Boolean,
            'default': false
        },
        notApplicable: {
            type: Boolean,
            'default': false
        }
    },
    computed: {
        colorClass () {
            return this.incorrect ? 'red--text font-weight-medium' : 'primary--text';
        }
    },
    created () {
        this.$root.$on('autocomplete', () => {
            this.questionValue = this.value ? +this.value : '';
        });

        this.questionValue = this.value ? +this.value : '';
    },
    watch: {
        value (val) {
            this.questionValue = val ? +val : '';
        }
    }
};
</script>
